export interface Pipeline {
  id: string;
  slug: string;
  name: string;
  description?: string;
  income_objective?: number;
  is_default: boolean;
  created_at: string;
  updated_at: string;
  company_id?: string;
  stages?: Stage[];
  permissions?: PipelinePermission[];
}

/**
 * Verifica si un pipeline es el pipeline principal
 * Un pipeline principal es aquel que tiene un array de permisos vacío
 */
export const isMainPipeline = (pipeline: Pipeline): boolean => {
  return (
    Array.isArray(pipeline.permissions) && pipeline.permissions.length === 0
  );
};

export interface PipelinePermission {
  id: string;
  pipeline_id: string;
  role_id: string;
  can_view: boolean;
  can_edit: boolean;
  can_delete: boolean;
  created_at: string;
  updated_at: string;
  pipeline?: Pipeline;
  role?: {
    id: string;
    name: string;
  };
}

export interface CreatePipelineRequest {
  name: string;
  description?: string;
  income_objective?: number;
  is_default?: boolean;
}

export interface CreatePipelinePermissionRequest {
  pipeline_id: string;
  role_id: string;
  can_view: boolean;
  can_edit: boolean;
  can_delete: boolean;
}

export interface PipelinesResponse {
  success: boolean;
  data: Pipeline[];
  pagination?: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
}

export interface PipelineResponse {
  success: boolean;
  data: Pipeline;
}

export interface PipelinePermissionsResponse {
  success: boolean;
  data: PipelinePermission[];
}

export interface PipelinePermissionResponse {
  success: boolean;
  data: PipelinePermission;
}

export type StageType =
  | "start"
  | "progress"
  | "end"
  | "closed_won"
  | "closed_lost";

export interface StageVisibilityConfig {
  value: number;
  unit: "hours" | "days" | "weeks" | "months";
}

export interface StageStagnationConfig {
  value: number;
  unit: "days" | "months" | "years";
  action: "notify" | "move_to_lost";
}

export interface StageAutoTransitionConfig {
  value: number;
  unit: "hours" | "days" | "months";
}

export interface Stage {
  id: string;
  pipeline_id: string;
  name: string;
  description?: string;
  color: string;
  order_position: number;
  stage_type: StageType;
  is_active: boolean;
  auto_transition_config?: StageAutoTransitionConfig | null;
  stagnation_config?: StageStagnationConfig | null;
  visibility_config?: StageVisibilityConfig | null;
  created_at: string;
  updated_at: string;
}

export interface CreateStageRequest {
  pipeline_id: string;
  name: string;
  description?: string;
  color: string;
  order_position: number;
  stage_type: StageType;
  is_active?: boolean;
  auto_transition_config?: StageAutoTransitionConfig | null;
  stagnation_config?: StageStagnationConfig | null;
  visibility_config?: StageVisibilityConfig | null;
}

export interface StagesResponse {
  success: boolean;
  data: Stage[];
}

export interface StageResponse {
  success: boolean;
  data: Stage;
}
